import { GeometryMultiPolygon } from '@mri/types';

export function polygonsFromGeoJson(geometry: GeometryMultiPolygon): Array<google.maps.Polygon>{
  if (geometry.type === 'MultiPolygon') {
    return geometry.coordinates.map(polygonCoordinates => {
      return new google.maps.Polygon({
        paths: polygonCoordinates.map(ring => ring.map(point => ({ lat: point[1], lng: point[0] }))),
        // Otras opciones como color, grosor de línea, etc.
      });
    });
  }
  return[];
}
